import React, { useEffect, useState } from "react";
import axios from "axios";
import { Tab, Header } from "semantic-ui-react";
import CompanyEmpListWithCat from "./CompanyEmpListWithCat";
import { useParams } from "react-router-dom";
import { BaseUrl, BaseUrlInvoice } from "../formcomponents/Constants";
const CompanyEmpList = () => {
  const [rowData, setrowData] = useState([]);
  const [activeTabIndex, setActiveTabIndex] = useState(0); // Initialize with the desired default tab index (e.g., 0 for the first tab)
  const { catId } = useParams();
  const color = "blue";

  useEffect(() => {
    getWorkCatList();
  }, [catId]);

  const getWorkCatList = () => {
    axios
      .post(BaseUrlInvoice + "/accounts/listSSCategory", {
        categoryType: 5,
      })
      .then((res) => {
        console.log("catogery id", res.data);

        const tempArr = [...rowData];

        for (let i = 0; i < res.data.length; i++) {
          tempArr.push({
            categoryId: res.data[i].categoryId,
            categoryName: res.data[i].categoryName,
          });
        }
        tempArr.push({
          categoryId: 0,
          categoryName: "All",
        });

        setrowData(tempArr);
        if (catId != "null") {
          const indexToSetActive = tempArr.findIndex(
            (item) => item.categoryId === Number(catId)
          );

          setActiveTabIndex(indexToSetActive);
        }
        // Find the index of the active tab based on the catId param
      })
      .catch((error) => console.log(error));
  };

  const handleTabChange = (e, { activeIndex }) => {
    console.log("activeIndex", activeIndex);
    setActiveTabIndex(activeIndex); // Update the active tab index when a tab is clicked
  };

  const panes = rowData.map((item, index) => ({
    menuItem: `${item.categoryName}`,
    render: () => (
      <Tab.Pane attached={false} key={index}>
        <CompanyEmpListWithCat categoryId={item.categoryId} />
      </Tab.Pane>
    ),
  }));

  return (
    <div>
      <Header dividing size="huge" as="h1">
        Company Employee List
      </Header>
      <Tab
        menu={{ color, attached: false, tabular: false }}
        panes={panes}
        activeIndex={activeTabIndex} // Set the active tab index
        onTabChange={handleTabChange} // Handle tab change events
      />
    </div>
  );
};

export default CompanyEmpList;
